import(/* webpackMode: "eager" */ "/vercel/path0/public/serv1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/serv2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/serv3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/serv4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/serv5.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/serv6.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/serv7.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/serv8.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/BlogsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/ExpertForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/FaqSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/FooterSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/ManageServices.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/NavbarSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/ServerPackagesDedServ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/ServerVideoSection.tsx");
